import type { IAnalyticsProvider } from './types';

const isDev = (import.meta as any).env?.DEV;

export class NoopProvider implements IAnalyticsProvider {
  trackEvent(event: string, properties?: Record<string, unknown>): void {
    if (isDev) console.debug('[analytics:noop] track', event, properties);
  }
  identifyUser(userId: string, traits?: Record<string, unknown>): void {
    if (isDev) console.debug('[analytics:noop] identify', userId, traits);
  }
  resetUser(): void {
    if (isDev) console.debug('[analytics:noop] reset');
  }
  pageView(path: string): void {
    if (isDev) console.debug('[analytics:noop] pageview', path);
  }
}
